import React from 'react';
import Link from './Link';
import { getTab } from './Utility';
import { Collapse } from 'react-bootstrap';

export default class TabBar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false
    }

    this.unlisten = window.historyObj.listen(function(location, action) { // eslint-disable-line no-unused-vars
      if (location.pathname === "/profile") this.setState({open: false});
    }.bind(this));

  }

  componentWillReceiveProps(newProps) {
    if (this.props.location !== newProps.location) {
      this.setState({open: false});
    }
  }

  toggleOpen() {
    this.setState({open: !this.state.open});
  }

  render() {

    const menuButton = (
      <div className="menu" onClick={this.toggleOpen.bind(this)}>
        <div className="whiteBar"/>
        <div className="whiteBar"/>
        <div className="whiteBar"/>
      </div>
    );

    var tabContent = null;
    if (this.props.ministry) {
      var tabs = [{label: "Announcements", to: "/announcements"}, {label: "Events", to: "/events"}, {label: "Recurring Events", to: "/recurring"}, {label: "Settings", to: "/settings"}];

      //if (this.props.ministry.type === "service") {
      //  tabs.push({label: "Help & Sign-ups", to: "/service"});
      //}

      tabContent = tabs.map(function(item, i) {
        var className = "";
        if (this.props.mobile) {
          className = ("/" + getTab(this.props.location) === item.to) ? "tabBarItemMobileSelected" :  "tabBarItemMobile";
        }
        else {
          className = ("/" + getTab(this.props.location) === item.to) ? "tabBarItemSelected" :  "tabBarItem";
        }
        return <Link to={"/" + this.props.ministry.key + item.to} onClick={() => { this.setState({open: false}) }} key={i}><button className={className}>{item.label}</button></Link>;
      }.bind(this));
    }

    const tabDropdown = (
      <div className="tabDropdown">
        <div className="tabDropdownInternal">
          {tabContent}
        </div>
      </div>
    );

    return (
      <div>
        {(this.props.mobile && tabContent !== null) ? menuButton : tabContent}
        <Collapse in={this.props.mobile && this.state.open}>{tabDropdown}</Collapse>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/util/TabBar.js
 **/